import { createApp } from 'vue';
import { createPinia } from 'pinia';
//import * as Sentry from "@sentry/vue";

import auth from '@lib/plugins/auth';
import '@lib/plugins/axios';
import router from '@/router';

// Main layout component from ef lib
import '@lib/plugins/bootstrap'; // Force load of bootstap
import App from '../../lib/js/layouts/Base.vue';

// Additionals
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/all.min.css';
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/solid.min.css';
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/brands.min.css';

import '@/../../public/css/color-dot.css';
import '@/../../public/css/helpers.css';

// Create main vue app
const pinia = createPinia();
const app = createApp(App);

// Sentry error tracking
/*Sentry.init({
    app,
    dsn: "https://c645f7e0fbdd55afff29a18d9cfbf7cd@o4508789338406912.ingest.de.sentry.io/4508790728884304",
});*/

// Load main plugins
app.use(pinia);
app.use(router);
app.use(auth);

// Internationalization: the user's pick, else the browser language
import I18n from '@lib/plugins/i18n';
import { merge } from 'lodash-es';

import lib_locale from '../../lib/js/locale';
import app_locales from '@/locale/index';

app.use(I18n, window.env.app?.env == 'e2e' ? {} : merge(lib_locale, app_locales));

// PrimeVue component library, see https://primefaces.org/primevue/showcase/#/
import PrimeVue from 'primevue/config';
app.use(PrimeVue);

// Load additional components from the ef libraray, eg. the layouts sidebar
// We use the plugin system style to enshure that the components are loaded in the propper order

import EfLib from '@lib/eflib';
import { eventSettingsTabs } from '@/pages/Event/Settings/settingsTabs';
app.use(EfLib, {
	// The settings of an event are the lib's page, these the app's tabs on it
	contributions: { slots: { 'context.settings': eventSettingsTabs } },
});

import AppBroadcastPlugin from '@lib/plugins/broadcast';
app.use(AppBroadcastPlugin);

// Load additional handfy plugins
import Moment from '@lib/plugins/moment';
app.use(Moment);

// The sidebar is custom and is defined in the app
import Sidebar from '@/sidebar';
app.use(Sidebar);

// The bell in the header: switched on and synced once a user is logged in
import Notification from '@lib/plugins/layouts/notification';
app.use(Notification);

// The context works pretty much the same in all apps and is only customized in the app
import { AppApplicationPlugin } from '@lib/plugins/layouts/application';
app.use(AppApplicationPlugin);

// The context works pretty much the same in all apps and is only customized in the app
import { AppContextPlugin } from '@lib/plugins/layouts/context';
app.use(AppContextPlugin);

import Filters from '@lib/filters';
app.use(Filters);

// Enable performance tracking
if (import.meta.env.DEV) {
	app.config.performance = true;
}

// Opt-in Material layer of the lib, loaded last so it wins over the base theme. Without this
// import the app falls back to the base design, see lib/js/sass/DESIGN.md
import '@lib/sass/app-material.scss';

// Mount the app
app.mount('#app');
